module.exports = __webpack_public_path__ + "img/jisushishi_bg.6f8ab051.png";